import { WebSocketMessageTypeIncoming } from "../../Enums/WebSocketMessageTypeIncoming";

export class MessageWebSocketIncoming {
    public Type?: WebSocketMessageTypeIncoming;
    public SessionId?: string;

    constructor(){

    }
}